// export function calculateEmployeeSalary({
//     gross,
//     rule,
//     benefits = {},
//     options = { meal: false, transport: false, health: false, includePF: true, includeESIC: true },
//     withoutPfCalculationRule
// }: {
//     gross: number;
//     rule: any;
//     benefits?: any;
//     options?: { meal?: boolean; transport?: boolean; health?: boolean; includePF?: boolean; includeESIC?: boolean };
//     withoutPfCalculationRule: any
// }) {
//     if (!gross || !rule) return null;
//     const {
//         basic_Percentage, min_Basic, min_Gross_Salary,
//         pF_Employee_Percentage, pF_Employer_Percentage, pF_Wage_Cap,
//         esiC_Wage_Limit, esiC_Employee_Percentage, esiC_Employer_Percentage,
//         hrA_Percentage, conveyance_Percentage
//     } = rule;

//     if (gross < min_Gross_Salary) return null;

//     let basic: number;

//     if (gross >= min_Basic) {
//         basic = Math.round((gross * basic_Percentage) / 100);
//         if (basic < min_Basic) basic = min_Basic;
//     } else {
//         basic = Math.round(gross);
//     }

//     const pfBasic = Math.min(basic, pF_Wage_Cap);

//     let employeePF = 0;
//     let employerPF = 0;

//     if (options.includePF) {
//         employeePF = Math.round((pfBasic * pF_Employee_Percentage) / 100);
//         employerPF = Math.round((pfBasic * pF_Employer_Percentage) / 100);
//     }

  

//     // ---- ESIC ----
//     // isEligibleForESIC = whether gross falls under the wage limit at all (rule-driven, always true/false)
//     // esicToggleOn = the user's checkbox choice, defaults to true when not provided
//     const isEligibleForESIC = gross <= esiC_Wage_Limit;
//     const esicToggleOn = options.includeESIC !== false;
//     const applyESIC = isEligibleForESIC && esicToggleOn;

//     const esicEmployee = applyESIC ? Math.round((gross * esiC_Employee_Percentage) / 100) : 0;
//     const esicEmployer = applyESIC ? Math.round((gross * esiC_Employer_Percentage) / 100) : 0;
//     // ---- /ESIC ----

//     const remaining = gross - basic;
//     let hra = 0;
//     let conveyance = 0;

//     if (remaining > 0) {
//         hra = Math.round((gross * hrA_Percentage) / 100);
//         conveyance = Math.round((gross * conveyance_Percentage) / 100);
//         if (hra > remaining) {
//             hra = remaining;
//             conveyance = 0;
//         } else {
//             conveyance = remaining - hra;
//         }
//     }

//     const meal = options.meal ? benefits.meal_Allowance ?? 0 : 0;
//     const transport = options.transport ? benefits.transportation_Allowance ?? 0 : 0;
//     const health = options.health && gross > esiC_Wage_Limit ? benefits.health_Insurance_Coverage ?? 0 : 0;

//     const monthlyCTC = gross + employerPF + esicEmployer + meal + transport + health;
//     // esicEmployee is 0 when toggle is off, so it's simply no longer subtracted here —
//     // that amount stays inside gross and flows into netSalary automatically.
//     const netSalary = gross - (employeePF + esicEmployee);

//     return {
//         basic,
//         pfBasic,
//         hra,
//         conveyance,
//         employeePF,
//         employerPF,
//         esicEmployee,
//         esicEmployer,
//         monthlyCTC,
//         annualCTC: monthlyCTC * 12,
//         netSalary,
//         totalDeduction: employeePF + esicEmployee,
//         esicApplicable: isEligibleForESIC // wage-limit eligibility, independent of the checkbox
//     };
// }


// export const calculateInternSalary = ({ gross, rule, benefits, options, }: { gross: number; rule: any; benefits: any; options: { meal?: boolean; transport?: boolean; health?: boolean; includePF?: boolean; includeESIC?: boolean; }; }) => {
//     if (!gross || !rule) return null;
//     const { basic_Percentage, min_Basic, pF_Employee_Percentage, pF_Employer_Percentage, pF_Wage_Cap, esiC_Wage_Limit, esiC_Employee_Percentage, esiC_Employer_Percentage, hrA_Percentage, conveyance_Percentage, } = rule;

//     let basic = (gross * basic_Percentage) / 100;
//     if (basic < min_Basic) basic = min_Basic;

//     const basicSalary = Math.round(basic);
//     const pfBasic = Math.min(basicSalary, pF_Wage_Cap);

//     let employeePF = 0;
//     let employerPF = 0;

//     if (options.includePF) {
//         employeePF = Math.round((pfBasic * pF_Employee_Percentage) / 100);
//         employerPF = Math.round((pfBasic * pF_Employer_Percentage) / 100);
//     }

//     const isEligibleForESIC = gross <= esiC_Wage_Limit;
//     const esicToggleOn = options.includeESIC !== false;
//     const applyESIC = isEligibleForESIC && esicToggleOn;

//     const esicEmployee = applyESIC ? Math.round((gross * esiC_Employee_Percentage) / 100) : 0;
//     const esicEmployer = applyESIC ? Math.round((gross * esiC_Employer_Percentage) / 100) : 0;

//     const remaining = gross - basicSalary;
//     const hra = Math.round((remaining * hrA_Percentage) / 100);
//     const conveyance = Math.round((remaining * conveyance_Percentage) / 100);

//     const mealAllowance = options.meal ? benefits?.meal_Allowance ?? 0 : 0;
//     const transportAllowance = options.transport ? benefits?.transportation_Allowance ?? 0 : 0;
//     const healthInsurance = gross > esiC_Wage_Limit && options.health ? benefits?.health_Insurance_Coverage ?? 0 : 0;

//     const monthlyCTC = gross + employerPF + esicEmployer + mealAllowance + transportAllowance + healthInsurance;
//     const annualCTC = monthlyCTC * 12;
//     const netSalary = gross - employeePF - esicEmployee;

//     return { basic: basicSalary, pfBasic, employeePF, employerPF, esicEmployee, esicEmployer, hra, conveyance, monthlyCTC, annualCTC, netSalary, esicApplicable: isEligibleForESIC, };
// };













export function calculateEmployeeSalary({
    gross,
    rule,
    benefits = {},
    options = { meal: false, transport: false, health: false, includePF: true, includeESIC: true },
    withoutPfCalculationRule
}: {
    gross: number;
    rule: any;
    benefits?: any;
    options?: { meal?: boolean; transport?: boolean; health?: boolean; includePF?: boolean; includeESIC?: boolean };
    withoutPfCalculationRule: any
}) {
    if (!gross || !rule) return null;
    const {
        basic_Percentage, min_Basic, min_Gross_Salary,
        pF_Employee_Percentage, pF_Employer_Percentage, pF_Wage_Cap,
        esiC_Wage_Limit, esiC_Employee_Percentage, esiC_Employer_Percentage,
        hrA_Percentage, conveyance_Percentage
    } = rule;

    if (gross < min_Gross_Salary) return null;

    let basic: number;

    if (gross >= min_Basic) {
        basic = Math.round((gross * basic_Percentage) / 100);
        if (basic < min_Basic) basic = min_Basic;
    } else {
        basic = Math.round(gross);
    }

    const pfBasic = Math.min(basic, pF_Wage_Cap);

    let employeePF = 0;
    let employerPF = 0;

    if (options.includePF) {
        employeePF = Math.round((pfBasic * pF_Employee_Percentage) / 100);
        employerPF = Math.round((pfBasic * pF_Employer_Percentage) / 100);
    }

    // ---- ESIC ----
    // isWithinWageLimit = whether gross falls under the wage limit *right now* — this is
    // informational only (used by the UI to warn "over limit, will stop at next cycle").
    // It must NOT be used to auto-stop an already-running ESIC deduction mid-contribution-period.
    // Per company policy: once ESIC is active, it stays active until the twice-yearly
    // scheduler (Apr / Oct cycle) explicitly closes it out — even if gross crosses the
    // wage limit in between.
    const isWithinWageLimit = gross <= esiC_Wage_Limit;
    const esicToggleOn = options.includeESIC !== false;
    const applyESIC = esicToggleOn; // deduction follows the stored/persisted toggle only

    const esicEmployee = applyESIC ? Math.round((gross * esiC_Employee_Percentage) / 100) : 0;
    const esicEmployer = applyESIC ? Math.round((gross * esiC_Employer_Percentage) / 100) : 0;
    // ---- /ESIC ----

    const remaining = gross - basic;
    let hra = 0;
    let conveyance = 0;

    if (remaining > 0) {
        hra = Math.round((gross * hrA_Percentage) / 100);
        conveyance = Math.round((gross * conveyance_Percentage) / 100);
        if (hra > remaining) {
            hra = remaining;
            conveyance = 0;
        } else {
            conveyance = remaining - hra;
        }
    }

    const meal = options.meal ? benefits.meal_Allowance ?? 0 : 0;
    const transport = options.transport ? benefits.transportation_Allowance ?? 0 : 0;
    const health = options.health && gross > esiC_Wage_Limit ? benefits.health_Insurance_Coverage ?? 0 : 0;

    const monthlyCTC = gross + employerPF + esicEmployer + meal + transport + health;
    const netSalary = gross - (employeePF + esicEmployee);

    return {
        basic,
        pfBasic,
        hra,
        conveyance,
        employeePF,
        employerPF,
        esicEmployee,
        esicEmployer,
        monthlyCTC,
        annualCTC: monthlyCTC * 12,
        netSalary,
        totalDeduction: employeePF + esicEmployee,
        esicApplicable: esicToggleOn,     // now reflects the actual applied/enrolled state
        isOverWageLimit: !isWithinWageLimit // UI-only flag: gross currently exceeds the limit
    };
}


export const calculateInternSalary = ({ gross, rule, benefits, options, }: { gross: number; rule: any; benefits: any; options: { meal?: boolean; transport?: boolean; health?: boolean; includePF?: boolean; includeESIC?: boolean; }; }) => {
    if (!gross || !rule) return null;
    const { basic_Percentage, min_Basic, pF_Employee_Percentage, pF_Employer_Percentage, pF_Wage_Cap, esiC_Wage_Limit, esiC_Employee_Percentage, esiC_Employer_Percentage, hrA_Percentage, conveyance_Percentage, } = rule;

    let basic = (gross * basic_Percentage) / 100;
    if (basic < min_Basic) basic = min_Basic;

    const basicSalary = Math.round(basic);
    const pfBasic = Math.min(basicSalary, pF_Wage_Cap);

    let employeePF = 0;
    let employerPF = 0;

    if (options.includePF) {
        employeePF = Math.round((pfBasic * pF_Employee_Percentage) / 100);
        employerPF = Math.round((pfBasic * pF_Employer_Percentage) / 100);
    }

    // Same ESIC-period-lock rule as calculateEmployeeSalary — see comment there.
    const isWithinWageLimit = gross <= esiC_Wage_Limit;
    const esicToggleOn = options.includeESIC !== false;
    const applyESIC = esicToggleOn;

    const esicEmployee = applyESIC ? Math.round((gross * esiC_Employee_Percentage) / 100) : 0;
    const esicEmployer = applyESIC ? Math.round((gross * esiC_Employer_Percentage) / 100) : 0;

    const remaining = gross - basicSalary;
    const hra = Math.round((remaining * hrA_Percentage) / 100);
    const conveyance = Math.round((remaining * conveyance_Percentage) / 100);

    const mealAllowance = options.meal ? benefits?.meal_Allowance ?? 0 : 0;
    const transportAllowance = options.transport ? benefits?.transportation_Allowance ?? 0 : 0;
    const healthInsurance = gross > esiC_Wage_Limit && options.health ? benefits?.health_Insurance_Coverage ?? 0 : 0;

    const monthlyCTC = gross + employerPF + esicEmployer + mealAllowance + transportAllowance + healthInsurance;
    const annualCTC = monthlyCTC * 12;
    const netSalary = gross - employeePF - esicEmployee;

    return {
        basic: basicSalary, pfBasic, employeePF, employerPF, esicEmployee, esicEmployer, hra, conveyance,
        monthlyCTC, annualCTC, netSalary,
        esicApplicable: esicToggleOn,
        isOverWageLimit: !isWithinWageLimit,
    };
};
